<app-section appInView [ngClass]="{sticky: sticky}" (intersect)="intersected($event)" width="10000px" [padding]="padding" [theme]="theme">
    <div class="wrapper">
        <button mat-icon-button (click)="GoBack()" aria-label="Go Back">
            <mat-icon>navigate_before</mat-icon>
        </button>
        <h1>{{ title }}</h1>
    </div>
</app-section>